import React from "react";
import PropTypes from "prop-types";

import BaseChart from "./BaseChart";

// change yLabel to yAxisText for consistancy 
// add default export for consistancy

export class LineChart extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.array
      })
    ).isRequired,
    colors: PropTypes.array,
    decimals: PropTypes.number,
    xMax: PropTypes.number,
    xMin: PropTypes.number,
    xAxisType: PropTypes.oneOf([
      "linear",
      "logarithmic",
      "datetime",
      "category"
    ]),
    yMin: PropTypes.number,
    yMax: PropTypes.number,
    yAxisType: PropTypes.oneOf([
      "linear",
      "logarithmic",
      "datetime",
      "category"
    ]),
    categories: PropTypes.array,
    yAxisText: PropTypes.string,
    zoomType: PropTypes.string
  };

  render() {
    const {
      // name,
      height,
      colors,
      series,
      decimals,
      xMax,
      xMin,
      xAxisType,
      yMin,
      yMax,
      yAxisType,
      categories,
      yAxisText,
      zoomType
    } = this.props;

    return (
      <BaseChart
        decimals={decimals}
        colors={colors}
        options={{
          chart: {
            type: "line",
            height: height,
            zoomType: zoomType
          },
          title: {
            text: null
          },
          series: series,
          xAxis: {
            softMin: xMin,
            softMax: xMax,
            categories: categories,
            type: xAxisType
          },
          yAxis: {
            softMin: yMin,
            softMax: yMax,
            title: {
              text: yAxisText
            },
            type: yAxisType
          }
        }}
      />
    );
  }
}

export default LineChart
